import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { ExpandableToFullHeight } from "@faire/retailer/components/ExpandableToFullHeight/ExpandableToFullHeight";
import { SDUIFilterablePaginatedSectionNavigationLink } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/CategoryNavigation/SDUIFilterablePaginatedSectionNavigationLink";
export var SDUIFilterablePaginatedSectionCategoryNavigationRenderer = function(param) {
    var navigationTree = param.navigationTree;
    var _navigationTree_navigation_group, _navigationTree_navigation_group1;
    if ((navigationTree === null || navigationTree === void 0 ? void 0 : (_navigationTree_navigation_group = navigationTree.navigation_group) === null || _navigationTree_navigation_group === void 0 ? void 0 : _navigationTree_navigation_group.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ExpandableToFullHeight, {
        children: /*#__PURE__*/ _jsx("nav", {
            style: {
                marginBottom: getSpacing("1x")
            },
            "data-test-id": "category-page-sidebar",
            children: /*#__PURE__*/ _jsx("ul", {
                children: navigationTree === null || navigationTree === void 0 ? void 0 : (_navigationTree_navigation_group1 = navigationTree.navigation_group) === null || _navigationTree_navigation_group1 === void 0 ? void 0 : _navigationTree_navigation_group1.map(function(navigationGroup, index) {
                    var _navigationGroup_group_title;
                    var listHeaderId = "category-list-header-".concat((_navigationGroup_group_title = navigationGroup.group_title) !== null && _navigationGroup_group_title !== void 0 ? _navigationGroup_group_title : "".toLowerCase().replace(" ", "-"));
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            navigationGroup.group_title ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    index > 0 ? /*#__PURE__*/ _jsx(Spacer, {
                                        size: "3x"
                                    }) : null,
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraphSansMedium",
                                        id: listHeaderId,
                                        children: navigationGroup.group_title
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: "1x"
                                    })
                                ]
                            }) : null,
                            navigationGroup.links.map(function(link) {
                                return /*#__PURE__*/ _jsx("li", {
                                    children: /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionNavigationLink, {
                                        navigationTreeLink: link
                                    })
                                }, link.identifier);
                            })
                        ]
                    }, listHeaderId);
                })
            })
        })
    });
};
